import { Carousel } from 'ui/components/compounds';
import { Picture } from 'ui/components/primitives';
import { placeholderImg } from 'ui/components/primitives/Image/Picture/Picture';

import { GiftsCarrouselButton } from './GiftsCarrouselButton';
import { GiftStyles } from '../Gifts.styles';

import type { Image } from 'core/domains/cart';
import type { ChooseItem, SelectedPromotion } from 'core/services/bff/@types';

type TGiftsCarrousel = {
  gift: ChooseItem;
  isCompleted: boolean;
  canAddItem: boolean;
  isMobile: boolean;
  alreadySelectedPromotion?: SelectedPromotion;
  index: number;
};

const GiftsCarrousel = ({
  gift,
  isCompleted,
  canAddItem,
  isMobile,
  alreadySelectedPromotion,
  index,
}: TGiftsCarrousel) => (
  <GiftStyles.WrapperCarousel>
    {!isMobile && gift.items.length >= 5 && <GiftStyles.RemainingContentIndicator />}
    <Carousel.Container
      container={true}
      desktop={true}
      dots
      itemsPerPage={{ desktop: isMobile ? 2 : 5, mobile: 5 }}
      navigationSize="sm"
    >
      {gift.items.map(({ available, visible, name, images, sku }: ChooseItem['items'][0], i) => (
        <Carousel.Slide key={i}>
          <GiftStyles.Sku
            data-testid={`gift-item-${gift.promotion.code}-${sku}`}
            data-visible={true}
            spacing="small"
          >
            <Picture
              alt={`gift-item-${gift.promotion}`}
              opacity={available ? '100' : '25'}
              ratio="4x3"
              sources={[
                {
                  srcSet:
                    images.flatMap(({ url }: Image) => url).filter(Boolean)[0] || placeholderImg,
                },
              ]}
              src={images[0]?.url}
            />
            <GiftStyles.SkuNumber>
              <span>{sku}</span>
            </GiftStyles.SkuNumber>
            <GiftStyles.TextName variant="body-medium-short">{name}</GiftStyles.TextName>
            <GiftsCarrouselButton
              available={available || visible}
              isCompleted={isCompleted}
              isDisabled={canAddItem}
              max={gift.giftQuantity}
              item={{ gift, sku, index }}
              quantity={
                alreadySelectedPromotion?.rewards?.find((reward) => reward.sku === sku)?.quantity ||
                0
              }
            />
          </GiftStyles.Sku>
        </Carousel.Slide>
      ))}
    </Carousel.Container>
  </GiftStyles.WrapperCarousel>
);

export default GiftsCarrousel;
